
import topbar from './topbar';
import ast from './ast';

const astPlugin = {
  install(Vue) {
    const copyVue = Vue;
    const pluginOption = {
      // ==============APP模块================
      isAPP: ast.isAPP,
      gotoAPP: ast.gotoAPP,
      setAPPShare: ast.setAPPShare,
      goAPPShare: ast.goAPPShare,
      disableAPPShare: ast.disableAPPShare,
      makeAPPShareCallBack: ast.makeAPPShareCallBack,
      openView: ast.openView,
      getPlatform: ast.getPlatform,
      initAPPShare: ast.initAPPShare,
      callGame: ast.callAndDownLoadGame,
      getFlowRequestExtData: ast.getFlowRequestExtData,
      getAstConfig: ast.getAstConfig, // 导出兼容方法
      currentAstConfig: ast.currentAstConfig,
      currentAstName: ast.currentAstName,
      setImageShare: ast.setImageShare,
      imageShare: ast.imageShare,
      getShareUrl: ast.getShareUrl,
      openScheme: ast.openScheme,
    };
    // ==============入口模块===================
    const astName = ast.currentAstName();
    switch (astName) {
      case 'TGCLUB': {
        pluginOption.entryPoint = topbar.initTgclubTopbar; // 初始化头部下载导航
        break;
      }
      case 'BB': {
        pluginOption.entryPoint = topbar.initBbTopbar; // 初始化头部下载导航
        break;
      }
      default:
        break;
    }
    copyVue.prototype.$astCommercialPlugin = pluginOption;
  },
};
export default astPlugin;
